"use client";

/** The listing card's loading shape (the listings grid, the history
 *  page). Its own module: importing it from ListingsGrid pulled the whole
 *  grid (filters, map view) into pages that only wanted the placeholder. */
export function SkeletonCard() {
  return (
    <div className="flex flex-col rounded-xl border border-gray-200 bg-white overflow-hidden animate-pulse">
      {/* Image block */}
      <div className="aspect-[4/3] bg-gray-200" />
      {/* Body */}
      <div className="flex flex-col flex-1 p-3 gap-2.5">
        {/* Price row */}
        <div className="flex items-baseline justify-between gap-2">
          <div className="h-5 w-24 rounded bg-gray-200" />
          <div className="h-3 w-14 rounded bg-gray-200" />
        </div>
        {/* Facts row */}
        <div className="flex items-center gap-2.5">
          <div className="h-3 w-12 rounded bg-gray-200" />
          <div className="h-3 w-14 rounded bg-gray-200" />
          <div className="h-3 w-16 rounded bg-gray-200" />
        </div>
        {/* Building-type chip */}
        <div className="h-4 w-20 rounded bg-gray-200" />
        {/* Location row */}
        <div className="h-3 w-2/3 rounded bg-gray-200 mt-auto" />
      </div>
    </div>
  );
}
